import { Brand } from "../../../types/brand";

export function getBrandsWithoutMain(brands: Brand[] | null, mainBrandId: number | null): Brand[] {
  if (!brands?.length || !mainBrandId) return [];
  return brands.filter((b) => b.id !== mainBrandId);
}

export function getDefaultCompetitor(params: {
  mainBrandId: number | null;
  bestCompetitor: Brand | null;
  brandsWithoutMain: Brand[];
}): Brand | null {
  const { mainBrandId, bestCompetitor, brandsWithoutMain } = params;
  if (!mainBrandId) return null;
  if (bestCompetitor && bestCompetitor.id !== mainBrandId) return bestCompetitor;
  return brandsWithoutMain[0] || null;
}

export function resolveCompetitor(params: {
  mainBrandId: number | null;
  brandsWithoutMain: Brand[];
  selectedCompetitorBrand: Brand | null;
  defaultCompetitor: Brand | null;
}): { resolved: Brand | null; isStoredValid: boolean } {
  const { mainBrandId, brandsWithoutMain, selectedCompetitorBrand, defaultCompetitor } = params;
  if (!mainBrandId) return { resolved: null, isStoredValid: false };

  const isStoredValid =
    Boolean(selectedCompetitorBrand) &&
    selectedCompetitorBrand!.id !== mainBrandId &&
    brandsWithoutMain.some((b) => b.id === selectedCompetitorBrand!.id);

  return { resolved: isStoredValid ? selectedCompetitorBrand : defaultCompetitor, isStoredValid };
}

